<sharry-header></sharry-header>
<div class="not-found">
  <a [routerLink]="'explore' | routeTranslate">
    <img
      class="logo"
      alt="sharry logo"
      src="https://media.sharry.land/app/images/logo-sharry-full.svg" />
  </a>
  <div class="not-found__card">
    <div class="not-found__card__image"></div>
    <h2>{{ 'not-found.title' | i18next }}</h2>
    <p class="bigger">{{ 'not-found.hint' | i18next }}</p>
  </div>
  <button
    class="sharry-medium"
    color="primary"
    mat-flat-button
    [routerLink]="'explore' | routeTranslate">
    {{ 'not-found.action' | i18next }}
  </button>
</div>

<sharry-footer class="is-not-mobile"></sharry-footer>
